import {ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-test-bfq-instructions',
    templateUrl: './test-bfq-instructions.component.html',
    styleUrls: ['./test-bfq-instructions.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestBfqInstructionsComponent {
    @Output() selected = new EventEmitter<string>();

    nextStep(): void {
        this.selected.next('next');
    }

    previousStep(): void {
        this.selected.next('previous');
    }
}
